/* tslint:disable:no-string-literal */

import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[focus]',
    standalone: false
})
export class FocusDirective implements AfterViewInit, OnChanges {
    @Input('focus') hasFocus: boolean;

    constructor(private elementRef: ElementRef) { }

    ngAfterViewInit(): void {
        this.elementRef.nativeElement.focus();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['hasFocus'] && changes['hasFocus'].currentValue === true) {
            this.elementRef.nativeElement.focus();
        }
    }
}
